module.exports = __webpack_public_path__ + "static/media/send-fast.ebab4344.svg";